import('../pages/desktop/cabinet/spider');

$('.js-transcription-toggle').click(function (ev) {
    ev.preventDefault();

    $(this).parents('.js-transcription').find('.js-transcription-video').toggle();
});
